export const LOAD_SETTINGS = 'LOAD_SETTINGS';
export const LOAD_ACCUMULATION_SETTINGS = 'LOAD_ACCUMULATION_SETTINGS';
export const EDIT_ACCUMULATION_SETTINGS = 'EDIT_ACCUMULATION_SETTINGS';
export const ADD_WHITELIST_WALLET = 'ADD_WHITELIST_WALLET';
export const DELETE_WHITELIST_WALLET = 'DELETE_WHITELIST_WALLET';
export const LOAD_AML_BALANCE = 'LOAD_AML_BALANCE';
